
import "./App.css";
import { useRef} from "react";
import LandingPage from "./components/LandingPage";

function App() {
  const containerRef = useRef(null);

  return (
        <div className="w-full h-min justify-center flex flex-col items-center bg-white" data-scroll-container ref={containerRef}>
          <LandingPage />
        </div>
  );
}

export default App;
